import { render, staticRenderFns } from "./AppChecklistsNew.vue?vue&type=template&id=5574c25b&scoped=true&"
import script from "./AppChecklistsNew.vue?vue&type=script&lang=js&"
export * from "./AppChecklistsNew.vue?vue&type=script&lang=js&"
import style0 from "./AppChecklistsNew.vue?vue&type=style&index=0&id=5574c25b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5574c25b",
  null
  
)

export default component.exports